import { FormGroup } from "@angular/forms";

declare module '@angular/forms' {
	interface FormGroup {
		getDirtyValue(): {[key: string]: any}
	}
}

Object.defineProperty(FormGroup.prototype, 'getDirtyValue', {
	enumerable: false,
	value: function () {
        return Object.fromEntries(
            Object.entries((this as FormGroup).controls)
                  .filter(([_, c]) => c.touched && c.dirty)
                  .map(([k, c]) => [k, c.value])
        );
	}
});
